export { default } from './CardInfo';

